(function () {
  function fixMenuHeight(details) {
    var drawer = details.querySelector('.menu-drawer');
    if (!drawer) return;
    drawer.style.setProperty('height', 'auto', 'important');
    drawer.style.setProperty('max-height', 'fit-content', 'important');
    drawer.style.setProperty('overflow', 'visible', 'important');

    var inner = drawer.querySelector('.menu-drawer__inner-container');
    if (inner) {
      inner.style.setProperty('height', 'auto', 'important');
      inner.style.setProperty('max-height', 'fit-content', 'important');
    }

    var navContainer = drawer.querySelector('.menu-drawer__navigation-container');
    if (navContainer) {
      navContainer.style.setProperty('height', 'auto', 'important');
      navContainer.style.setProperty('max-height', 'fit-content', 'important');
      navContainer.style.setProperty('overflow-y', 'visible', 'important');
    }
  }

  function init() {
    var details = document.querySelector('.menu-drawer-container');
    if (!details) return;

    var main = document.getElementById('MainContent');
    if (main) {
      main.style.transition = 'filter 0.2s ease';
    }

    var observer = new MutationObserver(function () {
      var isOpen = details.hasAttribute('open') && details.classList.contains('menu-opening');
      if (isOpen) {
        fixMenuHeight(details);
        setTimeout(function () { fixMenuHeight(details); }, 20);
        setTimeout(function () { fixMenuHeight(details); }, 100);
        setTimeout(function () { fixMenuHeight(details); }, 300);
        if (main) main.style.filter = 'blur(8px)';
      } else {
        if (main) main.style.filter = '';
      }
    });

    observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
